export default {
  required: v => {
    return v != "" || "Por favor, preencha este campo";
  },

  email: v => {
    let rgx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
    return rgx.test(v) || "Por favor, informe um e-mail válido";
  },

  min6: v => {
    return (v && v.length >= 6) || "Por favor, digite no mínimo 6 digítos";
  },

  cpf: cpf => {
    let result = true;
    let soma;
    let resto;

    cpf = cpf.replace(/[^0-9]/g, "");

    soma = 0;
    if (cpf == "00000000000") result = false;

    for (var i = 1; i <= 9; i++)
      soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11;

    if (resto == 10 || resto == 11) resto = 0;
    if (resto != parseInt(cpf.substring(9, 10))) result = false;

    soma = 0;
    for (var i = 1; i <= 10; i++)
      soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;

    if (resto == 10 || resto == 11) resto = 0;
    if (resto != parseInt(cpf.substring(10, 11))) result = false;

    return result || "Por favor, informe um CPF válido";
  },

  // isNumber: value => {
  //   const pattern = /^-?(\d+\.?\d*)$|(\d*\.?\d+)$/;
  //   return pattern.test(value) ? true : "Campo deve ser numérico";
  // },

  isNumber: v => (v && !isNaN(v)) || "Campo deve ser numérico"
};
